import { styled as t } from "styled-components";
const e = t.div`
  margin-left: 8px;
`;
export {
  e as TooltipTextContainer
};
